import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function LightbulbSolidIcon(props) {
	return (
		<IconBase type="lightbulb-solid" {...props}>
			<path d="M9 19H15V19.5C15 20.0523 14.5523 20.5 14 20.5H10C9.44772 20.5 9 20.0523 9 19.5V19Z" />
			<path d="M15.5 14.874C17.0141 13.7848 18 12.0075 18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10C6 12.0075 6.98593 13.7848 8.5 14.874V16.5C8.5 17.0523 8.94772 17.5 9.5 17.5H14.5C15.0523 17.5 15.5 17.0523 15.5 16.5V14.874Z" />
		</IconBase>
	);
}
LightbulbSolidIcon.propTypes = iconPropTypes;
